<template>
  <section class="pa-section pa-section-park-detail">
    <div class="pa-back-button">
      <router-link :to="{ name: 'parks.view'}">←ひろば帳へ戻る</router-link>
    </div>

    <div class="park-info">
      <PAParkBanner
       :shoudExpandTextDefault="shoudExpandParkInfoTextDefault"
       :parkId="parkId"
       :couldExpandDescription="true"
       :couldDisplayAreaInfomationModal="true"
      />
    </div>

    <div class="clip-button">
      <PAParkClipButton
       :parkId="parkId"
      />
    </div>

    <div class="character-list">
      <PAParkCharacterListBanner
       :parkId="parkId"
      />
    </div>

    <div class="note-list-title">掲示物</div>

    <div class="note-list-view">
      <PAParkNoteListViewSet
       :parkId="parkId"
      />
    </div>

    <div class="pa-control-options">
      <PAUnClipButton
        v-if="!isAdminRole"
       :parkId="parkId"
      />
      
      <PAInvitationManageButton
        v-if="isAdminRole"
       :parkId="parkId"
      />
    </div>

    <PAParkManageInvitationModal
      v-if="isAdminRole"
     :parkId="parkId"
    />
  </section>
</template>

<script>
import PAParkBanner from '@/components/Parts/PAParkBanner/PAParkBanner.vue'

import PAParkNoteListViewSet from '@/components/Pages/Parks/Detail/PAParkNoteListViewSet/PAParkNoteListViewSet.vue'

import PAParkClipButton from '@/components/Pages/Parks/Detail/PAParkClipButton.vue'
import PAParkCharacterListBanner from '@/components/Pages/Parks/Detail/PAParkCharacterListBanner.vue'
import PAUnClipButton from '@/components/Pages/Parks/Detail/PAUnClipButton.vue'
import PAInvitationManageButton from '@/components/Pages/Parks/Detail/PAInvitationManageButton.vue'
import PAParkManageInvitationModal from '@/components/Pages/Parks/Detail/PAParkManageInvitationModal.vue'

import {GetParkData} from '@/graphql/queries/Park.graphql'

export default {
  components : {
    PAParkBanner,
    PAParkNoteListViewSet,
    PAParkClipButton,
    PAParkCharacterListBanner,
    PAUnClipButton,
    PAInvitationManageButton,
    PAParkManageInvitationModal
  },

  data(){
    return {
      isMountedPage : false,
      shoudExpandParkInfoTextDefault  : false,

      shouldRedirectHome  : false,
      isAdminRole : false,
    };
  },

  computed : {
    parkId(){
      return this.$route.params.parkId;
    }
  },

  apollo : {
    park : {
      query : GetParkData,

      variables(){
        return {
          id : this.parkId
        };
      },

      skip(){
        if(this.parkId === null){
          return true;
        }else{
          return false;
        }
      },

      result({data: {park}}){
        if(park === null){
          this.shouldRedirectHome = true;
        }
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },
  },

  watch : {
    shouldRedirectHome(){
      this.redirectHome();
    },

    isMountedPage(){
      this.setCreateButtonData();
      this.redirectHome();
    },

    park : {
      handler(data){
        if(typeof data === 'undefined') return;
        if(data === null) return;

        if(data.is_clipped === true){
          this.shoudExpandParkInfoTextDefault = false;
        }else{
          this.shoudExpandParkInfoTextDefault = true;
        }

        if(data.park_role === 'owner'){
          this.isAdminRole = true;
        }else{
          this.isAdminRole = false;
        }

        this.setCreateButtonData();
      },
      immediate: true,
      deep:true
    }
  },

  methods : {
    setCreateButtonData(){
      if(typeof this.park === 'undefined') return;
      if(this.park === null) return;

      if(this.$parent.$parent.isMountedLoginedPage !== true){
        if(this.isMountedPage === false) return;
      }
      
      let isOpenButton = true;

      if(this.park.is_clipped === true){
        isOpenButton = true;
      }else{
        isOpenButton = false;
      }

      this.$store.dispatch({
        type        : 'createButton/updateCreateButton',
        isOpen      : isOpenButton,
        contentType : 'park',
      });
    },

    redirectHome(){
      if(this.shouldRedirectHome === false) return;
      if(this.isMountedPage === false) return;
      
      this.$nextTick(() => {
        this.$store.dispatch({
          type        : 'flashMessage/updateFlashMessage',
          hasMessage  : true,
          message     : '&nbsp;このひろばは表示することができません。',
          status      : 'error',
          hasControl  : true,
          autoClose   : 3000
        }, {root:true});

        this.$router.push({ name: 'home' });
      });
    }
  },

  mounted(){
    this.$parent.$parent.$on('mountedPage', () => {
      this.isMountedPage = true;
    });
  },

  beforeDestroy(){
    this.$store.dispatch({
      type        : 'createButton/updateCreateButton',
      isOpen      : false
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-section{
  &-park-detail{
    padding-top:.5rem !important;
    margin-bottom:1.5rem;

    .pa-back-button{
      width:98%;
      margin:0 auto .3rem;

      @include from($desktop) {
        margin:.2rem auto .8rem;
      }

      a{
        display: block;
        background-color: #C2A78F;
        color: #7C5E49;
        font-size:.9rem;
        border-radius: 8px;
        padding:.2rem .6rem;
        text-align: center;
        letter-spacing: .1rem;
        user-select: none;

        @include from($desktop) {
          font-size:1.1rem;
        }
      }
    }

    .park-info{
      width:98%;
      margin:.8rem auto .6rem;

      @include from($desktop) {
        margin:1rem auto;
      }
    }

    .clip-button{
      width:98%;
      margin:0 auto;
      user-select: none;

      @include from($desktop) {
        margin:1rem auto;
      }
    }

    .character-list{
      width:98%;
      margin:.5rem auto 0;
    }

    .note-list-title{
      width:98%;
      margin:.6rem auto .5rem;
      background-color: #89620C;
      color:#D2BA9E;
      text-align: center;
      border-radius: 12px;
      font-weight: bold;
      letter-spacing: .1rem;
      user-select: none;
    }

    .note-list-view{
      width:98%;
      margin:.5rem auto;
    }

    .pa-control-options{
      margin:1rem .5rem .5rem;
    }
  }
}
</style>